

































import { Component, Ref, Mixins } from 'vue-property-decorator';
import catalogStore from '@/store/modules/catalog/module';
import CheckboxFilter from './commonFilters/CheckboxFilter.vue';
import DateRangeFilter from './commonFilters/DateRangeFilter.vue';
import AccountSettings from '@/mixins/accountSettings.mixin';

import { ScreenText } from '@/lang/ScreenText';
import { FilterListItem } from '@/Model/sessions/catalogTypes';

@Component({
  components: {
    CheckboxFilter,
    DateRangeFilter
  }
})

export default class CatalogFilters extends Mixins(AccountSettings) {
  private screenText = new ScreenText();
  shouldResetFilters = false;
  @Ref('programFilter') programFilter!: CheckboxFilter;
  @Ref('locationFilter') locationFilter!: CheckboxFilter;
  @Ref('dateRangeFilter') dateRangeFilter!: DateRangeFilter;

  get filterHeadingText(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_HEADING');
  }

  get programFilterTitle(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_PROGRAMS');
  }

  get locationFilterTitle(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_LOCATIONS');
  }

  get programFilterList(): Array<FilterListItem> {
    return catalogStore.programFilterOptions;
  }

  get locationFilterList(): Array<FilterListItem> {
    return catalogStore.locationFilterOptions;
  }

  get programsFilterEmptyText(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_PROGRAMS_EMPTY_TEXT');
  }

  get locationsFilterEmptyText(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_LOCATIONS_EMPTY_TEXT');
  }

  get disableClearAllFilter(): boolean {
    return catalogStore.isFilterDisabled || catalogStore.isLoadingSessions;
  }

  clearAllFilters() {
    this.programFilter.resetFilters();
    this.locationFilter.resetFilters();
    this.dateRangeFilter.resetFilters();
    catalogStore.SET_CURRENT_LOCATION_IDS_FILTERED([]);
    catalogStore.SET_CURRENT_PROGRAM_IDS_FILTERED([]);
    catalogStore.RESET_FILTER_DATA();
  }

  onProgramCheckboxChecked(checkedItem: FilterListItem, isAdded: boolean) {
    catalogStore.onProgramFilterListChange({ checkedItem, isAdded });
  }

  onLocationCheckboxChecked(checkedItem: FilterListItem, isAdded: boolean) {
    catalogStore.onLocationFilterListChange({ checkedItem, isAdded });
  }

  onDateFilterChanged(date: Date | null, type: string) {
    catalogStore.RESET_FILTER_DATA();
    if (type == 'dateTo') {
      catalogStore.SET_CURRENT_SESSION_DATE_END_FILTER(date);
    }
    else if (type == 'dateFrom') {
      catalogStore.SET_CURRENT_SESSION_DATE_START_FILTER(date);
    }
  }
}
